var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('ProChioseTree', {
    attrs: {
      "treeData": _vm._treeData,
      "visible": _vm.visible
    },
    on: {
      "onChange": _vm.onChange
    }
  });
};
var staticRenderFns = [];
export { render, staticRenderFns };